import { getDoc, doc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

import { db, functions } from '../../firebase-config';
import { BOOKING_PRICE_IDS, CONSULT_PRICE_IDS, parseAsCompressed } from '../../utils';

// Maps to Catalogue.name in Firestore
export const SERVICES = {
  CONSULT: 'consultation',
  TRANSFER_SCRIPT: 'script admin fee',
  BOOKING_FEE: 'booking fee',
};

export const PAYMENT_URLS = {
  [SERVICES.CONSULT]: '/consult-payment-success',
  [SERVICES.BOOKING_FEE]: '/booking-payment-success',
  [SERVICES.TRANSFER_SCRIPT]: '/script-payment-success',
  default: '/payment-success',
};

/**
 * @param {object} params - Parameters.
 * @param {string} params.formName - Name of the form.
 * @param {string[]} params.productIds - IDs of the products.
 * @param {boolean} [params.isScriptMode=false] - Indicates if the script mode is active.
 * @returns {string} - URL of the success page.
 */
export const getPaymentSuccessUrl = ({  productIds, formName: formCategory, isScriptMode = false }) => {
  // already deprecated
  if (isScriptMode) {
    return PAYMENT_URLS[SERVICES.TRANSFER_SCRIPT];
  }
  
  // booking success 
  if (productIds.every(id => BOOKING_PRICE_IDS.includes(id))) {
    return PAYMENT_URLS[SERVICES.BOOKING_FEE];
  }
  
  // checkup or consult
  // For checkups, the formName will be 'checkup', which acts as the identifier.
  if (productIds.every(id => CONSULT_PRICE_IDS.includes(id))) {
    const params = parseAsCompressed.serialize({ formCategory, consultIds: productIds });

    return `${PAYMENT_URLS[SERVICES.CONSULT]}?q=${params}`;
  }

  // we can now add additional parameters in the product payment success page
  // like summary of the products or any related information

  return PAYMENT_URLS.default;
};

export const PAYMENT_PROCESSORS = {
  NOVATTI: 'novatti',
  TILL: 'till',
};

/**
 * Get the payment processor in firestore DB /public/payment_data document.
 * @returns {Promise<string>} - payment processor string.
 */

export const getPaymentProcessor = async () =>
  (await getDoc(doc(db, 'public', 'payment_data'))).data()?.paymentProcessor || '';

// TODO: DELETE ALL NOVATTI JUNE 9th, 2025
/**
 * Makes a typed cloud function call with error handling
 * @param {Object} params - The parameters for the function
 * @param { "tillRefundConsult_v2" | "tillRefundProduct_v2" | "novattiRefundOrder_v2" | "novattiRefundProduct_v2" } params.functionName - The name of the function to call
 * @param {Object} params.data - The data to pass to the function
 *
 */
export const refundProcessor = async ({ data, functionName }) => {
  if (!functionName) {
    throw new Error('Refund function name is required!!!');
  }

  try {
    const response = await httpsCallable(functions, functionName)(data);
    return response;
  } catch (error) {
    return { data: { error: true, message: error.message } };
  }
};
